import { CalendarPlus, Calendar, ChevronDown } from "lucide-react";
import { buildCalendarLinks } from "@/lib/calendar";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

const providers = [
  { key: "google", label: "Google Calendar" },
  { key: "outlook", label: "Outlook.com" },
  { key: "office365", label: "Office 365" },
  { key: "yahoo", label: "Yahoo Calendar" },
];

export const AddToCalendar = ({ content, variant = "light" }) => {
  const p = content.couple || {};
  const events = content.events || [];
  const start = events[0]?.date ? new Date(`${events[0].date}T10:00:00`) : new Date(content.wedding_date);
  const lastDate = events[events.length - 1]?.date;
  const end = lastDate
    ? new Date(`${lastDate}T22:00:00`)
    : new Date(new Date(content.wedding_date).getTime() + 36 * 3600 * 1000);

  const links = buildCalendarLinks({
    title: `${p.partner1} & ${p.partner2}'s Wedding`,
    start,
    end,
    location: content.venue ? `${content.venue.name}, ${content.venue.address}` : content.hero?.location_label,
    description: `${content.tagline || ""} ${content.hashtag || ""}`.trim(),
  });

  const open = (key) => window.open(links[key], "_blank", "noopener,noreferrer");

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          data-testid="add-to-calendar"
          className="rounded-full px-6 py-3 text-sm font-medium transition-all hover:scale-105 border flex items-center gap-2"
          style={variant === "light"
            ? { borderColor: "rgba(255,255,255,0.55)", color: "#fff", backgroundColor: "rgba(255,255,255,0.08)" }
            : { borderColor: "var(--gold)", color: "var(--gold-hover)" }}
        >
          <CalendarPlus className="w-4 h-4" /> Add to Calendar
          <ChevronDown className="w-3.5 h-3.5 opacity-70" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="center" className="w-52" data-testid="add-to-calendar-menu">
        {providers.map((prov) => (
          <DropdownMenuItem
            key={prov.key}
            onClick={() => open(prov.key)}
            data-testid={`add-to-calendar-${prov.key}`}
            className="cursor-pointer gap-2"
          >
            <Calendar className="w-4 h-4 text-[var(--gold)]" /> {prov.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
